import React from "react";
import NotificationWidget from "ui/crfs/notification_widget";
import DividerLine from "ui/crfs/divider_line";
import styles from "./dropdown.module.css";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CheckIcon from "@mui/icons-material/Check";
import ElementTitle from "../element_title";

export default function DropDown(props) {
  const { title, options, uval, onUpdate, show_checkmark, disabled, field, read_only } = props;

  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.input_flex}>
        <div className={styles.left_split}>
          <div>
            <ElementTitle required={field?.required} title={title} />
          </div>
        </div>
        <div className={[styles["right-split"], styles.dropdown_entry].join(" ")}>
          <div>
            {read_only ? (
              <div>{options.find((o) => o.value === uval)?.label || ""}</div>
            ) : (
              <Select
                disabled={disabled}
                value={uval || ""}
                sx={{
                  fontSize: 14,
                  minWidth: 200,
                  height: 30,
                  padding: 0,
                  alignSelf: "center",
                }}
                onChange={(e) => {
                  onUpdate(e.target.value);
                }}
              >
                {options &&
                  options.length &&
                  options.map((o) => (
                    <MenuItem key={o.value} value={o.value}>
                      {o.label}
                    </MenuItem>
                  ))}
              </Select>
            )}
          </div>
          {show_checkmark ? (
            <div className={styles.check_mark}>
              <CheckIcon sx={{ color: "green" }} />
            </div>
          ) : null}
        </div>
      </div>

      <DividerLine />
    </div>
  );
}
